import { render, staticRenderFns } from "./DialogBaseActions.vue?vue&type=template&id=828cd176&"
import script from "./DialogBaseActions.vue?vue&type=script&lang=js&"
export * from "./DialogBaseActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardActions})
